"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[753],{

/***/ 43605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94589);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71849);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: transparent;\n    border-radius: 12px;\n    box-shadow: ",
        ";\n    color: ",
        ";\n    display: block;\n    font-size: 14px;\n    height: ",
        ";\n    outline: 0;\n    padding: 0 16px;\n    width: 100%;\n    border: 2px solid ",
        ";\n\n    &::placeholder {\n        color: ",
        ";\n    }\n\n    &:disabled {\n        background-color: ",
        ";\n        box-shadow: none;\n        color: ",
        ";\n        cursor: not-allowed;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * Priority: Warning --> Success
 */ var getBoxShadow = function(param) {
    var _isSuccess = param.isSuccess, isSuccess = _isSuccess === void 0 ? false : _isSuccess, _isWarning = param.isWarning, isWarning = _isWarning === void 0 ? false : _isWarning, theme = param.theme;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.inset;
};
var getHeight = function(param) {
    var _scale = param.scale, scale = _scale === void 0 ? _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD : _scale;
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.SM */ .Q.SM:
            return "32px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.LG */ .Q.LG:
            return "46px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD:
        default:
            return "46px";
    }
};
var Input = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-705d548b-0"
})(_templateObject(), getBoxShadow, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, getHeight, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text90;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
});
Input.defaultProps = {
    scale: _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD,
    isSuccess: false,
    isWarning: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 76376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94589);
/* harmony import */ var _Box_Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6538);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43605);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71849);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        " {\n        padding-left: ",
        ";\n        padding-right: ",
        ";\n        /* background-color: transparent; */\n        /* border-radius: 8px; */\n        /* border: 2px solid ",
        "; */\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    align-items: center;\n    display: flex;\n    height: 100%;\n    position: absolute;\n    top: 0;\n\n    ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var getPadding = function(scale, hasIcon) {
    if (!hasIcon) {
        return "16px";
    }
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.SM */ .Q.SM:
            return "32px";
        case _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.LG */ .Q.LG:
            return "56px";
        case _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.MD */ .Q.MD:
        default:
            return "48px";
    }
};
var StyledInputGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_Box_Box__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-17dc6244-0"
})(_templateObject(), _Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, function(param) {
    var hasStartIcon = param.hasStartIcon, scale = param.scale;
    return getPadding(scale, hasStartIcon);
}, function(param) {
    var hasEndIcon = param.hasEndIcon, scale = param.scale;
    return getPadding(scale, hasEndIcon);
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var InputIcon = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-17dc6244-1"
})(_templateObject1(), function(param) {
    var isEndIcon = param.isEndIcon, scale = param.scale;
    return isEndIcon ? "\n    right: ".concat(scale === _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.SM */ .Q.SM ? "8px" : "16px", ";\n  ") : "\n    left: ".concat(scale === _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.SM */ .Q.SM ? "8px" : "16px", ";\n  ");
});
var InputGroup = function(_param) /*#__PURE__*/ {
    var _scale = _param.scale, scale = _scale === void 0 ? _types__WEBPACK_IMPORTED_MODULE_3__/* .scales.MD */ .Q.MD : _scale, startIcon = _param.startIcon, endIcon = _param.endIcon, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "scale",
        "startIcon",
        "endIcon",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledInputGroup, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        scale: scale,
        width: "100%",
        position: "relative",
        hasStartIcon: !!startIcon,
        hasEndIcon: !!endIcon
    }, props), {
        children: [
            startIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InputIcon, {
                scale: scale,
                children: startIcon
            }),
            /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(children, {
                scale: scale
            }),
            endIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InputIcon, {
                scale: scale,
                isEndIcon: true,
                children: endIcon
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InputGroup);


/***/ }),

/***/ 71849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; }
/* harmony export */ });
var scales = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};


/***/ }),

/***/ 83024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 6V7.79C12 8.24 12.54 8.46 12.85 8.14L15.64 5.35C15.84 5.15 15.84 4.84 15.64 4.64L12.85 1.85C12.54 1.54 12 1.76 12 2.21V4C7.58 4 4 7.58 4 12C4 13.04 4.2 14.04 4.57 14.95C4.84 15.62 5.7 15.8 6.21 15.29C6.48 15.02 6.59 14.61 6.44 14.25C6.15 13.56 6 12.79 6 12C6 8.69 8.69 6 12 6ZM17.79 8.71C17.52 8.98 17.41 9.4 17.56 9.75C17.84 10.45 18 11.21 18 12C18 15.31 15.31 18 12 18V16.21C12 15.76 11.46 15.54 11.15 15.86L8.36 18.65C8.16 18.85 8.16 19.16 8.36 19.36L11.15 22.15C11.46 22.46 12 22.24 12 21.8V20C16.42 20 20 16.42 20 12C20 10.96 19.8 9.96 19.43 9.05C19.16 8.38 18.3 8.2 17.79 8.71Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 31063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useCallWithMarketGasPrice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64487);







function useCallWithMarketGasPrice() {
    /**
     * Perform a contract call with a gas price returned from useGasPrice
     * @param contract Used to perform the call
     * @param methodName The name of the method called
     * @param methodArgs An array of arguments to pass to the method
     * @param overrides An overrides object to pass to the method. gasPrice passed in here will take priority over the price returned by useGasPrice
     * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
     */ var callWithMarketGasPrice = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(contract, methodName) {
            var methodArgs, overrides, contractMethod, tx, ref;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        methodArgs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [], overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null;
                        (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .addBreadcrumb */ .n_)({
                            type: "Transaction",
                            message: "Call with market gas price",
                            data: {
                                contractAddress: contract.address,
                                methodName: methodName,
                                methodArgs: methodArgs,
                                overrides: overrides
                            }
                        });
                        contractMethod = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contract, methodName);
                        return [
                            4,
                            contractMethod.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(methodArgs).concat([
                                (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, overrides)
                            ]))
                        ];
                    case 1:
                        tx = _state.sent();
                        if (tx) {
                            ;
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .addBreadcrumb */ .n_)({
                                type: "Transaction",
                                message: "Transaction sent: ".concat(tx.hash),
                                data: {
                                    hash: tx.hash,
                                    from: tx.from,
                                    gasLimit: (ref = tx.gasLimit) === null || ref === void 0 ? void 0 : ref.toString(),
                                    nonce: tx.nonce
                                }
                            });
                        }
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
        return function(contract, methodName) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        callWithMarketGasPrice: callWithMarketGasPrice
    };
}


/***/ }),

/***/ 62729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NO": function() { return /* reexport */ IconCheck; },
  "PQ": function() { return /* reexport */ IconDeleteImage; },
  "Rf": function() { return /* reexport */ IconNote; },
  "bC": function() { return /* reexport */ IconUpload; },
  "bn": function() { return /* reexport */ IconUploadFile; },
  "oX": function() { return /* reexport */ IconUploadImage; },
  "FC": function() { return /* reexport */ IconWarning; }
});

// UNUSED EXPORTS: IconLogo, IconNoData, IconStatus, IconStatusUp, IconTrade

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/icons/icon-trade.tsx



var IconTrade = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({}, props), {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18.3333 7.08341C18.3333 10.0751 15.9083 12.5001 12.9167 12.5001C12.775 12.5001 12.625 12.4918 12.4833 12.4834C12.275 9.84176 10.1583 7.72507 7.51666 7.51674C7.50832 7.37507 7.5 7.22508 7.5 7.08341C7.5 4.09175 9.925 1.66675 12.9167 1.66675C15.9083 1.66675 18.3333 4.09175 18.3333 7.08341Z",
                stroke: "#23262F",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.4993 12.9167C12.4993 15.9083 10.0743 18.3333 7.08268 18.3333C4.09102 18.3333 1.66602 15.9083 1.66602 12.9167C1.66602 9.925 4.09102 7.5 7.08268 7.5C7.22435 7.5 7.37434 7.50832 7.51601 7.51666C10.1577 7.72499 12.2744 9.84168 12.4827 12.4833C12.491 12.625 12.4993 12.775 12.4993 12.9167Z",
                stroke: "#23262F",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.65768 1.66675H2.49935C2.04102 1.66675 1.66602 2.04175 1.66602 2.50008V4.65841C1.66602 5.40008 2.56601 5.77507 3.09101 5.25007L5.24934 3.09174C5.76601 2.56674 5.39935 1.66675 4.65768 1.66675Z",
                stroke: "#23262F",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.3408 18.3332H17.4991C17.9574 18.3332 18.3324 17.9582 18.3324 17.4999V15.3416C18.3324 14.5999 17.4325 14.2249 16.9075 14.7499L14.7491 16.9082C14.2325 17.4332 14.5991 18.3332 15.3408 18.3332Z",
                stroke: "#23262F",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/icons/icon-status-up.tsx



var IconStatusUp = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({}, props), {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5.73242 15.7499C5.39076 15.7499 5.10742 15.4666 5.10742 15.1249V13.3999C5.10742 13.0582 5.39076 12.7749 5.73242 12.7749C6.07409 12.7749 6.35742 13.0582 6.35742 13.3999V15.1249C6.35742 15.4749 6.07409 15.7499 5.73242 15.7499Z",
                fill: "#292D32"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 15.7501C9.65833 15.7501 9.375 15.4667 9.375 15.1251V11.6667C9.375 11.3251 9.65833 11.0417 10 11.0417C10.3417 11.0417 10.625 11.3251 10.625 11.6667V15.1251C10.625 15.4751 10.3417 15.7501 10 15.7501Z",
                fill: "#292D32"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.2676 15.75C13.9259 15.75 13.6426 15.4667 13.6426 15.125V9.94165C13.6426 9.59998 13.9259 9.31665 14.2676 9.31665C14.6092 9.31665 14.8926 9.59998 14.8926 9.94165V15.125C14.8926 15.475 14.6176 15.75 14.2676 15.75Z",
                fill: "#292D32"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.73266 10.9834C5.44933 10.9834 5.19933 10.7918 5.12433 10.5084C5.041 10.1751 5.24099 9.83343 5.58266 9.75009C8.64933 8.98343 11.3493 7.30843 13.4077 4.91676L13.791 4.46676C14.016 4.20843 14.4077 4.1751 14.6743 4.4001C14.9327 4.6251 14.966 5.01676 14.741 5.28343L14.3577 5.73343C12.1327 8.33343 9.19933 10.1418 5.88266 10.9668C5.83266 10.9834 5.78266 10.9834 5.73266 10.9834Z",
                fill: "#292D32"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.2659 7.93333C13.9242 7.93333 13.6409 7.65 13.6409 7.30833V5.5H11.8242C11.4826 5.5 11.1992 5.21667 11.1992 4.875C11.1992 4.53333 11.4826 4.25 11.8242 4.25H14.2659C14.6076 4.25 14.8909 4.53333 14.8909 4.875V7.31667C14.8909 7.65833 14.6159 7.93333 14.2659 7.93333Z",
                fill: "#292D32"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.4993 18.9584H7.49935C2.97435 18.9584 1.04102 17.0251 1.04102 12.5001V7.50008C1.04102 2.97508 2.97435 1.04175 7.49935 1.04175H12.4993C17.0243 1.04175 18.9577 2.97508 18.9577 7.50008V12.5001C18.9577 17.0251 17.0243 18.9584 12.4993 18.9584ZM7.49935 2.29175C3.65768 2.29175 2.29102 3.65841 2.29102 7.50008V12.5001C2.29102 16.3417 3.65768 17.7084 7.49935 17.7084H12.4993C16.341 17.7084 17.7077 16.3417 17.7077 12.5001V7.50008C17.7077 3.65841 16.341 2.29175 12.4993 2.29175H7.49935Z",
                fill: "#292D32"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/icons/icon-status.tsx



var IconStatus = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({}, props), {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M2.04102 12.4751C2.93268 15.3418 5.33269 17.5501 8.31602 18.1584",
                stroke: "#292D32",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1.70898 9.15008C2.13398 4.94175 5.68398 1.66675 10.0006 1.66675C14.3173 1.66675 17.8673 4.95008 18.2923 9.15008",
                stroke: "#292D32",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.6758 18.1666C14.6508 17.5583 17.0424 15.3749 17.9508 12.5166",
                stroke: "#292D32",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/icons/icon-warning.tsx



var IconWarning = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.6666 7.99992C14.6666 11.6818 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6818 1.33325 7.99992C1.33325 4.31802 4.31802 1.33325 7.99992 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992ZM7.99992 7.33325C8.36811 7.33325 8.66659 7.63173 8.66659 7.99992V11.3338C8.66659 11.702 8.36811 12.0005 7.99992 12.0005C7.63173 12.0005 7.33325 11.702 7.33325 11.3338V7.99992C7.33325 7.63173 7.63173 7.33325 7.99992 7.33325ZM7.99992 5.99992C8.36811 5.99992 8.66659 5.70144 8.66659 5.33325C8.66659 4.96506 8.36811 4.66659 7.99992 4.66659C7.63173 4.66659 7.33325 4.96506 7.33325 5.33325C7.33325 5.70144 7.63173 5.99992 7.99992 5.99992Z",
            fill: "#9A9FA5"
        })
    }));
};

;// CONCATENATED MODULE: ./src/icons/icon-no-data.tsx



var IconNoData = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({}, props), {
        width: "91",
        height: "80",
        viewBox: "0 0 91 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("mask", {
                id: "mask0_232_18160",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "0",
                width: "82",
                height: "80",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M48.215 80C70.4523 80 88.4862 62.1017 88.4862 40C88.4862 17.8983 70.4523 0 48.215 0C25.9777 0 7.94385 17.8983 7.94385 40C7.94385 62.1017 25.9777 80 48.215 80Z",
                    fill: "#EAEEF9"
                })
            }),
            /*#__PURE__*/ _jsxs("g", {
                mask: "url(#mask0_232_18160)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M48.2712 80C70.5085 80 88.5424 62.1017 88.5424 40C88.5424 17.8983 70.5085 0 48.2712 0C26.0339 0 8 17.8983 8 40C8 62.1017 26.0339 80 48.2712 80Z",
                        fill: "#EAEEF9"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M79.063 34.7793V59.2538C79.063 64.3386 74.9274 68.4742 69.7748 68.4742H26.7918C21.7071 68.4742 17.5715 64.4064 17.5037 59.3216C17.5037 59.2538 17.5037 59.2538 17.5037 59.186V34.7793C17.5037 34.7115 17.5037 34.7115 17.5037 34.6437C17.5037 34.5081 17.5037 34.3725 17.5715 34.2369C17.6393 34.0335 17.7071 33.8979 17.7748 33.6945L29.3003 11.6606C29.707 10.7793 30.5884 10.3047 31.5376 10.3047H64.9613C65.9104 10.3047 66.724 10.7793 67.1986 11.6606L78.724 33.6945C78.7918 33.8301 78.8596 34.0335 78.9274 34.2369C79.063 34.3725 79.063 34.5759 79.063 34.7793Z",
                        fill: "url(#paint0_linear_232_18160)"
                    }),
                    /*#__PURE__*/ _jsx("g", {
                        filter: "url(#filter0_d_232_18160)",
                        children: /*#__PURE__*/ _jsx("path", {
                            d: "M57.0961 34.9831H39.6723C38.9266 34.9831 38.3164 34.4407 38.3164 33.6271V9.83054C38.3164 9.08478 38.8588 8.47461 39.6723 8.47461H57.0283C57.774 8.47461 58.3842 9.01698 58.3842 9.83054V33.6271C58.3842 34.3729 57.8418 34.9831 57.0961 34.9831Z",
                            fill: "#F5F8FF"
                        })
                    }),
                    /*#__PURE__*/ _jsx("g", {
                        filter: "url(#filter1_d_232_18160)",
                        children: /*#__PURE__*/ _jsx("path", {
                            d: "M62.8599 40.61H33.9107C32.9616 40.61 32.2158 39.7965 32.2158 38.9151V15.7965C32.2158 14.8473 33.0294 14.1016 33.9107 14.1016H62.8599C63.809 14.1016 64.5548 14.9151 64.5548 15.7965V38.9151C64.487 39.8643 63.809 40.61 62.8599 40.61Z",
                            fill: "#F5F8FF"
                        })
                    }),
                    /*#__PURE__*/ _jsx("g", {
                        filter: "url(#filter2_d_232_18160)",
                        children: /*#__PURE__*/ _jsx("path", {
                            d: "M66.181 47.1868H30.6556C29.6387 47.1868 28.7573 46.3054 28.7573 45.3563V22.5766C28.7573 21.5597 29.6387 20.7461 30.6556 20.7461H66.181C67.198 20.7461 68.0793 21.6274 68.0793 22.5766V45.2885C68.0116 46.3732 67.198 47.1868 66.181 47.1868Z",
                            fill: "#F5F8FF"
                        })
                    }),
                    /*#__PURE__*/ _jsx("g", {
                        filter: "url(#filter3_d_232_18160)",
                        children: /*#__PURE__*/ _jsx("path", {
                            d: "M69.7743 53.5594H27.0625C25.9099 53.5594 25.0286 52.6102 25.0286 51.5933V29.1526C25.0286 28.0001 25.9777 27.1865 27.0625 27.1865H69.7743C70.9269 27.1865 71.8082 28.1357 71.8082 29.1526V51.5255C71.7404 52.678 70.9269 53.5594 69.7743 53.5594Z",
                            fill: "#F5F8FF"
                        })
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M56.9609 36.0675H40.8931C40.4864 36.0675 40.0796 35.7286 40.0796 35.254C40.0796 34.8472 40.4186 34.4404 40.8931 34.4404H56.9609C57.3677 34.4404 57.7745 34.7794 57.7745 35.254C57.7745 35.7286 57.4355 36.0675 56.9609 36.0675Z",
                        fill: "#E6ECF5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M52.283 40.8134H31.9441C31.6729 40.8134 31.4695 40.61 31.4695 40.3388C31.4695 40.0676 31.6729 39.8643 31.9441 39.8643H52.2152C52.4864 39.8643 52.6898 40.0676 52.6898 40.3388C52.8254 40.4744 52.622 40.8134 52.283 40.8134Z",
                        fill: "#E6ECF5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M65.6381 40.8134H55.4008C55.1297 40.8134 54.9263 40.61 54.9263 40.3388C54.9263 40.0676 55.1297 39.8643 55.4008 39.8643H65.5703C65.8415 39.8643 66.0449 40.0676 66.0449 40.3388C66.1805 40.4744 65.9771 40.8134 65.6381 40.8134Z",
                        fill: "#E6ECF5"
                    }),
                    /*#__PURE__*/ _jsx("g", {
                        filter: "url(#filter4_d_232_18160)",
                        children: /*#__PURE__*/ _jsx("path", {
                            d: "M75.5259 36.0064V59.2105C75.5259 62.5107 72.8856 65.151 69.5254 65.151H27.0418C23.7415 65.151 21.0413 62.5107 21.0413 59.2105V35.8864C21.0413 35.7664 21.0413 35.6464 21.1013 35.5264H32.7485C34.7887 35.5264 36.4688 37.1465 36.4688 39.2467C36.4688 40.2668 36.8889 41.2268 37.5489 41.8869C38.269 42.607 39.1091 42.967 40.1892 42.967H57.1159C59.1561 42.967 60.8363 41.3469 60.8363 39.2467C60.8363 38.2266 61.2563 37.2665 61.9163 36.6065C62.6364 35.8864 63.4765 35.5264 64.4966 35.5264H75.4058C75.5259 35.6464 75.5259 35.8264 75.5259 36.0064Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ _jsx("g", {
                        filter: "url(#filter5_d_232_18160)",
                        children: /*#__PURE__*/ _jsx("path", {
                            d: "M79.063 34.7797V61.7627C79.063 65.4915 76.0799 68.4746 72.2833 68.4746H24.2833C20.5545 68.4746 17.5037 65.4915 17.5037 61.7627V34.6441C17.5037 34.5085 17.5037 34.3729 17.5715 34.2373H33.0291C35.3342 34.2373 37.2325 36.0678 37.2325 38.4407C37.2325 39.5932 37.707 40.678 38.4528 41.4237C39.2664 42.2373 40.2155 42.6441 41.4359 42.6441H55.1986C57.5037 42.6441 59.402 40.8136 59.402 38.4407C59.402 37.2882 59.8765 36.2034 60.6223 35.4576C61.4359 34.6441 62.385 34.2373 63.5376 34.2373H78.9274C79.063 34.3729 79.063 34.5763 79.063 34.7797Z",
                            fill: "url(#paint1_linear_232_18160)"
                        })
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M72.2828 58.7119H58.3167C57.8421 58.7119 57.4353 58.3729 57.4353 57.8306C57.4353 57.356 57.7743 56.9492 58.3167 56.9492H72.1472C72.6217 56.9492 73.0285 57.2882 73.0285 57.8306C73.0963 58.2374 72.6895 58.7119 72.2828 58.7119Z",
                        fill: "#E6ECF5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M66.0455 62.9834H58.3167C57.8421 62.9834 57.4353 62.6444 57.4353 62.1021C57.4353 61.6275 57.7743 61.2207 58.3167 61.2207H65.9777C66.4523 61.2207 66.859 61.5597 66.859 62.1021C66.9268 62.5088 66.52 62.9834 66.0455 62.9834Z",
                        fill: "#E6ECF5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M61.2366 65.8307C60.9654 66.9832 60.5586 68.2035 60.0841 69.2205C58.7959 71.729 56.762 73.6951 54.2536 74.9832C51.6773 76.2713 48.6264 76.8137 45.5756 76.1357C38.3214 74.5764 33.7112 67.5934 35.2027 60.4069C36.6942 53.2205 43.6773 48.5425 50.8637 50.1019C53.44 50.6442 55.6773 51.9324 57.5756 53.6951C60.8298 56.8815 62.118 61.4239 61.2366 65.8307Z",
                        fill: "url(#paint2_linear_232_18160)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M52.418 61.8987H49.3671V58.8479C49.3671 58.2377 48.8925 57.6953 48.2146 57.6953C47.6044 57.6953 47.062 58.1699 47.062 58.8479V61.8987H44.0112C43.401 61.8987 42.8586 62.3733 42.8586 63.0512C42.8586 63.7292 43.3332 64.2038 44.0112 64.2038H47.062V67.2546C47.062 67.8648 47.5366 68.4072 48.2146 68.4072C48.8247 68.4072 49.3671 67.9326 49.3671 67.2546V64.2038H52.418C53.0281 64.2038 53.5705 63.7292 53.5705 63.0512C53.5705 62.3733 53.0281 61.8987 52.418 61.8987Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M87.4579 20.8816C88.993 20.8816 90.2375 19.6371 90.2375 18.1019C90.2375 16.5668 88.993 15.3223 87.4579 15.3223C85.9227 15.3223 84.6782 16.5668 84.6782 18.1019C84.6782 19.6371 85.9227 20.8816 87.4579 20.8816Z",
                fill: "#EAEEF9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M84.6778 11.864C85.7263 11.864 86.5761 11.0141 86.5761 9.96569C86.5761 8.91728 85.7263 8.06738 84.6778 8.06738C83.6294 8.06738 82.7795 8.91728 82.7795 9.96569C82.7795 11.0141 83.6294 11.864 84.6778 11.864Z",
                fill: "#EAEEF9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.7965 18.1013C8.8449 18.1013 9.6948 17.2514 9.6948 16.203C9.6948 15.1546 8.8449 14.3047 7.7965 14.3047C6.74809 14.3047 5.89819 15.1546 5.89819 16.203C5.89819 17.2514 6.74809 18.1013 7.7965 18.1013Z",
                fill: "#EAEEF9"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.52542 59.8643C5.47246 59.8643 7.05085 58.2859 7.05085 56.3389C7.05085 54.3919 5.47246 52.8135 3.52542 52.8135C1.57839 52.8135 0 54.3919 0 56.3389C0 58.2859 1.57839 59.8643 3.52542 59.8643Z",
                fill: "#EAEEF9"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "filter0_d_232_18160",
                        x: "16.3164",
                        y: "-12.5254",
                        width: "64.0679",
                        height: "70.5088",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ _jsx("feOffset", {
                                dy: "1"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "11"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_232_18160"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_232_18160",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "filter1_d_232_18160",
                        x: "10.2158",
                        y: "-6.89844",
                        width: "76.3389",
                        height: "70.5088",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ _jsx("feOffset", {
                                dy: "1"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "11"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_232_18160"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_232_18160",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "filter2_d_232_18160",
                        x: "6.75732",
                        y: "-0.253906",
                        width: "83.322",
                        height: "70.4404",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ _jsx("feOffset", {
                                dy: "1"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "11"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_232_18160"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_232_18160",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "filter3_d_232_18160",
                        x: "3.02856",
                        y: "6.18652",
                        width: "90.7795",
                        height: "70.373",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ _jsx("feOffset", {
                                dy: "1"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "11"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_232_18160"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_232_18160",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "filter4_d_232_18160",
                        x: "8.04126",
                        y: "19.5264",
                        width: "80.4846",
                        height: "55.625",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ _jsx("feOffset", {
                                dy: "-3"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "6.5"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_232_18160"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_232_18160",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "filter5_d_232_18160",
                        x: "-4.49634",
                        y: "23.2373",
                        width: "105.559",
                        height: "78.2373",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ _jsx("feOffset", {
                                dy: "11"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "11"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_232_18160"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_232_18160",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_232_18160",
                        x1: "48.2882",
                        y1: "12.3254",
                        x2: "48.2882",
                        y2: "44.9754",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#B0BACC"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#969EAE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_232_18160",
                        x1: "48.2633",
                        y1: "33.4454",
                        x2: "48.2633",
                        y2: "68.8437",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FDFEFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9964",
                                stopColor: "#ECF0F5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_232_18160",
                        x1: "48.2168",
                        y1: "50.7268",
                        x2: "48.2168",
                        y2: "65.6726",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#B0BACC"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#969EAE"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/icons/icon-logo.tsx
var icon_logo = __webpack_require__(49430);
;// CONCATENATED MODULE: ./src/icons/icon-upload.tsx

var IconUpload = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "130",
        height: "130",
        viewBox: "0 0 180 180",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "180",
                height: "180",
                rx: "93",
                fill: "#355DFF",
                "fill-opacity": "0.1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M120.922 59.6055V84.2704H96.2272C93.3233 84.2704 90.5154 85.422 88.4755 87.4854C86.4356 89.5488 85.2597 92.332 85.2597 95.2352V130.889H60.5889C59.125 130.889 57.7331 130.313 56.7251 129.281C55.6932 128.274 55.1172 126.858 55.1172 125.418V70.0905C55.1172 68.6269 55.6932 67.2353 56.7251 66.2036C59.365 63.5643 64.5727 58.3579 67.2126 55.7186C68.2445 54.6869 69.6605 54.1111 71.1004 54.1111H115.426C118.45 54.1111 120.922 56.5584 120.922 59.6055Z",
                fill: props === null || props === void 0 ? void 0 : props.fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M96.2272 89.7648C94.7632 89.7648 93.3713 90.3406 92.3634 91.3723C91.3314 92.38 90.7554 93.7956 90.7554 95.2352V130.889H126.418C127.882 130.889 129.274 130.313 130.281 129.281C131.313 128.274 131.889 126.858 131.889 125.418V89.7648H96.2272Z",
                fill: "#232632"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M110.725 119.644V100.9",
                stroke: "#E4E8F9",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M110.725 100.846L101.375 109.692",
                stroke: "#E4E8F9",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M110.724 100.846L120.074 109.692",
                stroke: "#E4E8F9",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/icons/icon-upload-image.tsx

var IconUploadImage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "11",
        viewBox: "0 0 14 11",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.5 11V8H9.5L7 5L4.5 8H6.5V11H4V10.975C3.916 10.98 3.836 11 3.75 11C2.75544 11 1.80161 10.6049 1.09835 9.90165C0.395088 9.19839 0 8.24456 0 7.25C0 5.326 1.455 3.758 3.322 3.543C3.48569 2.68729 3.94244 1.91537 4.61371 1.36C5.28497 0.804629 6.12878 0.500528 7 0.5C7.87134 0.500488 8.71529 0.804553 9.38672 1.35991C10.0581 1.91527 10.5151 2.68721 10.679 3.543C12.546 3.758 13.999 5.326 13.999 7.25C13.999 8.24456 13.6039 9.19839 12.9006 9.90165C12.1974 10.6049 11.2436 11 10.249 11C10.165 11 10.084 10.98 9.999 10.975V11H7.5Z",
            fill: props === null || props === void 0 ? void 0 : props.fill
        })
    });
};

;// CONCATENATED MODULE: ./src/icons/icon-upload-file.tsx

var IconUploadFile = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.2072 9.79051C17.5977 10.181 17.5977 10.8142 17.2072 11.2047C16.8167 11.5953 16.1835 11.5953 15.793 11.2047L13.002 8.41379V15.5C13.002 16.0523 12.5543 16.5 12.002 16.5C11.4498 16.5 11.002 16.0523 11.002 15.5V8.41369L8.20906 11.2067C7.81854 11.5972 7.18537 11.5972 6.79485 11.2067C6.40432 10.8162 6.40432 10.183 6.79485 9.79247L11.2949 5.29242C11.4824 5.10488 11.7368 4.99952 12.002 4.99952C12.2672 4.99952 12.5216 5.10488 12.7091 5.29242L17.2072 9.79051Z",
                fill: "#1A1D1F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M4 14.5C4.55228 14.5 5 14.9477 5 15.5V17.5C5 18.0523 5.44772 18.5 6 18.5H18C18.5523 18.5 19 18.0523 19 17.5V15.5C19 14.9477 19.4477 14.5 20 14.5C20.5523 14.5 21 14.9477 21 15.5V17.5C21 19.1569 19.6569 20.5 18 20.5H6C4.34315 20.5 3 19.1569 3 17.5V15.5C3 14.9477 3.44772 14.5 4 14.5Z",
                fill: "#1A1D1F"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/icons/icon-delete-image.tsx

var IconDeleteImage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6.75 3.25V3.5H9.25V3.25C9.25 2.91848 9.1183 2.60054 8.88388 2.36612C8.64946 2.1317 8.33152 2 8 2C7.66848 2 7.35054 2.1317 7.11612 2.36612C6.8817 2.60054 6.75 2.91848 6.75 3.25ZM5.75 3.5V3.25C5.75 2.65326 5.98705 2.08097 6.40901 1.65901C6.83097 1.23705 7.40326 1 8 1C8.59674 1 9.16903 1.23705 9.59099 1.65901C10.0129 2.08097 10.25 2.65326 10.25 3.25V3.5H14C14.1326 3.5 14.2598 3.55268 14.3536 3.64645C14.4473 3.74021 14.5 3.86739 14.5 4C14.5 4.13261 14.4473 4.25979 14.3536 4.35355C14.2598 4.44732 14.1326 4.5 14 4.5H13.246L12.3 12.784C12.2302 13.3941 11.9384 13.9572 11.4801 14.3659C11.0218 14.7746 10.4291 15.0003 9.815 15H6.185C5.57093 15.0003 4.97823 14.7746 4.51993 14.3659C4.06162 13.9572 3.76976 13.3941 3.7 12.784L2.754 4.5H2C1.86739 4.5 1.74021 4.44732 1.64645 4.35355C1.55268 4.25979 1.5 4.13261 1.5 4C1.5 3.86739 1.55268 3.74021 1.64645 3.64645C1.74021 3.55268 1.86739 3.5 2 3.5H5.75ZM7 6.75C7 6.61739 6.94732 6.49021 6.85355 6.39645C6.75979 6.30268 6.63261 6.25 6.5 6.25C6.36739 6.25 6.24021 6.30268 6.14645 6.39645C6.05268 6.49021 6 6.61739 6 6.75V11.75C6 11.8826 6.05268 12.0098 6.14645 12.1036C6.24021 12.1973 6.36739 12.25 6.5 12.25C6.63261 12.25 6.75979 12.1973 6.85355 12.1036C6.94732 12.0098 7 11.8826 7 11.75V6.75ZM9.5 6.25C9.36739 6.25 9.24021 6.30268 9.14645 6.39645C9.05268 6.49021 9 6.61739 9 6.75V11.75C9 11.8826 9.05268 12.0098 9.14645 12.1036C9.24021 12.1973 9.36739 12.25 9.5 12.25C9.63261 12.25 9.75979 12.1973 9.85355 12.1036C9.94732 12.0098 10 11.8826 10 11.75V6.75C10 6.61739 9.94732 6.49021 9.85355 6.39645C9.75979 6.30268 9.63261 6.25 9.5 6.25Z",
            fill: "#E94A28"
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/icons/icon-check.tsx


var IconCheck = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 16.4375C5.1675 16.4375 2.0625 13.3325 2.0625 9.5C2.0625 5.6675 5.1675 2.5625 9 2.5625C12.8325 2.5625 15.9375 5.6675 15.9375 9.5C15.9375 13.3325 12.8325 16.4375 9 16.4375Z",
                stroke: "#11DC2E",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.65496 10.685L7.33496 9.36501",
                stroke: "#11DC2E",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.2953 8.045L8.65527 10.685",
                stroke: "#11DC2E",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/icons/icon-note.tsx


var IconNote = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "19",
        viewBox: "0 0 18 19",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9 2C4.8675 2 1.5 5.3675 1.5 9.5C1.5 13.6325 4.8675 17 9 17C13.1325 17 16.5 13.6325 16.5 9.5C16.5 5.3675 13.1325 2 9 2ZM8.4375 6.5C8.4375 6.1925 8.6925 5.9375 9 5.9375C9.3075 5.9375 9.5625 6.1925 9.5625 6.5V10.25C9.5625 10.5575 9.3075 10.8125 9 10.8125C8.6925 10.8125 8.4375 10.5575 8.4375 10.25V6.5ZM9.69 12.785C9.6525 12.8825 9.6 12.9575 9.5325 13.0325C9.4575 13.1 9.375 13.1525 9.285 13.19C9.195 13.2275 9.0975 13.25 9 13.25C8.9025 13.25 8.805 13.2275 8.715 13.19C8.625 13.1525 8.5425 13.1 8.4675 13.0325C8.4 12.9575 8.3475 12.8825 8.31 12.785C8.2725 12.695 8.25 12.5975 8.25 12.5C8.25 12.4025 8.2725 12.305 8.31 12.215C8.3475 12.125 8.4 12.0425 8.4675 11.9675C8.5425 11.9 8.625 11.8475 8.715 11.81C8.895 11.735 9.105 11.735 9.285 11.81C9.375 11.8475 9.4575 11.9 9.5325 11.9675C9.6 12.0425 9.6525 12.125 9.69 12.215C9.7275 12.305 9.75 12.4025 9.75 12.5C9.75 12.5975 9.7275 12.695 9.69 12.785Z",
            fill: "#E68C00"
        })
    });
};

;// CONCATENATED MODULE: ./src/icons/index.ts














/***/ }),

/***/ 21464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getDataStock; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var utils_multicall__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9796);
/* harmony import */ var config_abi_stocks_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15497);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97478);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70794);









var getDataStock = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(config, chainId, account) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, calls, getIsAdmin, result, resultAdmin, mergeShareHolders, mergeData, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    calls = [
                        {
                            address: config === null || config === void 0 ? void 0 : (ref = config.contract) === null || ref === void 0 ? void 0 : ref.address,
                            name: "ADMIN_ROLE",
                            params: []
                        },
                        {
                            address: config === null || config === void 0 ? void 0 : (ref1 = config.contract) === null || ref1 === void 0 ? void 0 : ref1.address,
                            name: "approver",
                            params: []
                        },
                        {
                            address: config === null || config === void 0 ? void 0 : (ref2 = config.contract) === null || ref2 === void 0 ? void 0 : ref2.address,
                            name: "issuePrice",
                            params: []
                        },
                        {
                            address: config === null || config === void 0 ? void 0 : (ref3 = config.contract) === null || ref3 === void 0 ? void 0 : ref3.address,
                            name: "totalSupply",
                            params: [
                                config__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_ID */ .IY
                            ]
                        },
                        {
                            address: config === null || config === void 0 ? void 0 : (ref4 = config.contract) === null || ref4 === void 0 ? void 0 : ref4.address,
                            name: "uri",
                            params: [
                                config__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_ID */ .IY
                            ]
                        },
                        {
                            address: config === null || config === void 0 ? void 0 : (ref5 = config.contract) === null || ref5 === void 0 ? void 0 : ref5.address,
                            name: "getShareholders",
                            params: []
                        },
                        {
                            address: config === null || config === void 0 ? void 0 : (ref6 = config.contract) === null || ref6 === void 0 ? void 0 : ref6.address,
                            name: "isManual",
                            params: []
                        }
                    ];
                    getIsAdmin = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                            var ref, calls, ref1, resultAdmin;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!((account === null || account === void 0 ? void 0 : account.length) > 0)) return [
                                            3,
                                            2
                                        ];
                                        calls = [
                                            {
                                                address: config === null || config === void 0 ? void 0 : (ref = config.contract) === null || ref === void 0 ? void 0 : ref.address,
                                                name: "hasRole",
                                                params: [
                                                    result[0][0],
                                                    account
                                                ]
                                            }
                                        ];
                                        return [
                                            4,
                                            (0,utils_multicall__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(config_abi_stocks_json__WEBPACK_IMPORTED_MODULE_1__, calls, chainId)
                                        ];
                                    case 1:
                                        ref1 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"].apply */ .Z.apply(void 0, [
                                            _state.sent(),
                                            1
                                        ]), resultAdmin = ref1[0];
                                        return [
                                            2,
                                            resultAdmin[0]
                                        ];
                                    case 2:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function getIsAdmin() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return [
                        4,
                        (0,utils_multicall__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(config_abi_stocks_json__WEBPACK_IMPORTED_MODULE_1__, calls, chainId)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        getIsAdmin()
                    ];
                case 2:
                    resultAdmin = _state.sent();
                    mergeShareHolders = (ref7 = result[5][0]) === null || ref7 === void 0 ? void 0 : ref7.map(function(dt) {
                        var ref;
                        return {
                            shareholderAddress: dt === null || dt === void 0 ? void 0 : dt.shareholder,
                            amount: new bignumber_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(dt === null || dt === void 0 ? void 0 : (ref = dt.numberOfShares) === null || ref === void 0 ? void 0 : ref.toString()).toString()
                        };
                    });
                    mergeData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, config), {
                        approvedAddress: result[1][0],
                        adminRole: result[0][0],
                        logo: result[4][0],
                        totalRelease: new bignumber_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z((ref8 = result[3][0]) === null || ref8 === void 0 ? void 0 : ref8.toString()).toString(),
                        issuePrice: new bignumber_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z((ref9 = result[2][0]) === null || ref9 === void 0 ? void 0 : ref9.toString()).toString(),
                        isAdmin: resultAdmin,
                        shareHolders: mergeShareHolders.filter(function(item) {
                            return new bignumber_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z(item.amount).isGreaterThan(0);
                        }),
                        isManual: result[6][0]
                    });
                    return [
                        2,
                        {
                            stock: mergeData
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        {
                            stock: null
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getDataStock(config, chainId, account) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 3972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ GetDataShareHolders; },
/* harmony export */   "n": function() { return /* binding */ UseCoreStock; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9473);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10355);
/* harmony import */ var config_constants_stocks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98289);
/* harmony import */ var _fetchDataStock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21464);







var GetDataShareHolders = function() {
    var dataShareHolders = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.shareholders;
    });
    return dataShareHolders;
};
var UseCoreStock = function(contractAddress, chainId, account) {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            var config, findItem, stockData;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_2__/* .fetchLoading */ .g)({
                            isLoading: !false
                        }));
                        return [
                            4,
                            (0,config_constants_stocks__WEBPACK_IMPORTED_MODULE_3__.getStocksConfig)(chainId)
                        ];
                    case 1:
                        config = _state.sent();
                        findItem = config === null || config === void 0 ? void 0 : config.find(function(dt) {
                            var ref, ref1;
                            return (dt === null || dt === void 0 ? void 0 : (ref = dt.contract) === null || ref === void 0 ? void 0 : (ref1 = ref.address) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === (contractAddress === null || contractAddress === void 0 ? void 0 : contractAddress.toLowerCase());
                        });
                        if (!findItem) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0,_fetchDataStock__WEBPACK_IMPORTED_MODULE_4__/* .getDataStock */ .Y)(findItem, chainId, account)
                        ];
                    case 2:
                        stockData = _state.sent();
                        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_2__/* .fetchDataStock */ .zV)(stockData));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_2__/* .fetchDataStock */ .zV)({
                            stock: null
                        }));
                        _state.label = 4;
                    case 4:
                        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_2__/* .fetchLoading */ .g)({
                            isLoading: false
                        }));
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        contractAddress,
        chainId,
        account
    ]);
};


/***/ }),

/***/ 27866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Auth; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx
var useAuth = __webpack_require__(49444);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Menu/config.ts
var config = __webpack_require__(4449);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(7447);
;// CONCATENATED MODULE: ./src/views/Auth/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: calc(100vh - ",
        'px);\n    flex-direction: column;\n    align-items:center;\n    justify-content: center;\n    /* background: url("/images/logo/bg_login.png?version=1.0");\n    background-size: contain;\n    background-repeat:no-repeat;\n    background-position: center; */\n    @media screen and (max-width: 600px){\n        height: 100%;\n    }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n    width: 700px;\n    height: 550px;\n    border-radius: 12px;\n    /* background: url("/images/logo/bg_container_login.png?version=1.0") ',
        ";\n    background-size: 100%;\n    background-repeat:no-repeat;\n    background-position: left; */\n    @media screen and (min-width: 601px) and (max-width: 1280px) {\n        width: 600px;\n        height: 450px;\n    }\n    @media screen and (max-width: 600px){\n        width: 100%;\n        height: 60vh;\n        border-radius: 0px;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    > img {\n        width: auto;\n        height: 350px;\n        @media screen and (min-width: 601px) and (max-width: 1440px){\n            width: 300px;\n            height: auto;\n        }\n        @media screen and (max-width: 600px){\n            width: auto;\n            height: 207px;\n        }\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 300px;\n    margin-top:2rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 300px;\n    margin-top:2rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n    @media screen and (max-width: 600px){\n        width: 100vw;\n        height: 90vh;\n        justify-content: flex-end;\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var PageFullWidth = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-bf915673-0"
})(_templateObject(), config/* MENU_HEIGHT */.d0);
var ContaierLogin = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-bf915673-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var ContainerImage = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-bf915673-2"
})(_templateObject2());
var CsButton = (0,styled_components_browser_esm/* default */.ZP)(ConnectWalletButton/* default */.Z).withConfig({
    componentId: "sc-bf915673-3"
})(_templateObject3());
var CsButtonLogout = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-bf915673-4"
})(_templateObject4());
var CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-bf915673-5"
})(_templateObject5());

// EXTERNAL MODULE: ./src/config/index.ts
var src_config = __webpack_require__(97478);
;// CONCATENATED MODULE: ./src/views/Auth/index.tsx







var AuthPage = function() {
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var logout = (0,useAuth/* default */.Z)().logout;
    var isWhitelist = src_config/* WHITE_LIST.find */.Im.find(function(dt) {
        return (dt === null || dt === void 0 ? void 0 : dt.toLowerCase()) === (account === null || account === void 0 ? void 0 : account.toLowerCase());
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageFullWidth, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlex, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContaierLogin, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerImage, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/logo/no_connect-wallet.png?version=1.0",
                            alt: "logo"
                        }),
                        account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonLogout, {
                            onClick: logout,
                            children: "Ngắt kết nối v\xed"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButton, {
                            children: "Kết nối v\xed"
                        }),
                        account && !isWhitelist && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            mt: "1rem",
                            color: "red",
                            children: [
                                "Địa chỉ v\xed hiện tại kh\xf4ng nằm trong whitelist. ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Vui l\xf2ng chuyển đổi v\xed kh\xe1c."
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Auth = (AuthPage);


/***/ })

}]);